module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"entry_and_exit":"Entry / Exit","to":"to"},"fr":{"entry_and_exit":"Entrée / Sortie","to":"à"},"de":{"entry_and_exit":"Ausgang eingeben","to":"Zu"}}')
  delete Component.options._Ctor
}
